import { doAppGraphqlRequest } from 'ducks/requests'

import {
  EMAIL_MARKETING_FETCH_INTEGRATIONS,
  EMAIL_MARKETING_GET_INTEGRATION_STATE,
  EMAIL_MARKETING_SUBSCRIBE,
  EMAIL_MARKETING_UNSUBSCRIBE,
} from './types'
import { emailMarketingIntegrationsNormalizationSchema } from './schema'

const fetchEmailMarketingIntegrationsQuery = `
  query FetchEmailMarketingIntegrationsQuery {
    emailMarketingIntegrations {
      nodes {
        id
        lists {
          id
          name
        }
        type
      }
    }
  }
`
export function doFetchEmailMarketingIntegrations() {
  return doAppGraphqlRequest(
    EMAIL_MARKETING_FETCH_INTEGRATIONS,
    fetchEmailMarketingIntegrationsQuery,
    {},
    { normalizationSchema: emailMarketingIntegrationsNormalizationSchema }
  )
}

const fetchEmailMarketingIntegrationStateQuery = `
  query FetchEmailMarketingIntegrationState($contactId: ID!, $integrationId: ID!) {
    emailMarketingSubscriptions(contactId: $contactId, integrationId: $integrationId) {
      nodes {
        externalUrl
        id
        listId
        listName
        subscribedAt
      }
    }
  }
`

export function doFetchEmailMarketingIntegrationState(
  integrationId,
  contactId
) {
  if (!contactId) return null
  return doAppGraphqlRequest(
    EMAIL_MARKETING_GET_INTEGRATION_STATE,
    fetchEmailMarketingIntegrationStateQuery,
    { contactId, integrationId },
    {
      requestKey: `FetchEmailMarketingIntegrationState:${integrationId}:${contactId}`,
    }
  )
}

const subscribeToEmailListMutation = `
  mutation SubscribeToEmailListMutation($input: EmailMarketingSubscriptionCreateInput!) {
    emailMarketingSubscriptionCreate(input: $input) {
      errors {
        message
      }
    }
  }
`

export function doSubscribeToEmailList(integrationId, contactId, list) {
  return doAppGraphqlRequest(
    EMAIL_MARKETING_SUBSCRIBE,
    subscribeToEmailListMutation,
    { input: { contactId, integrationId, listId: list.id } },
    {
      meta: {
        list: {
          id: list.id,
          listId: list.id,
          listName: list.name,
          subscribedAt: new Date(),
        },
      },
    }
  )
}

const unsubscribeToEmailListMutation = `
  mutation UnsubscribeToEmailListMutation($input: EmailMarketingSubscriptionDeleteInput!) {
    emailMarketingSubscriptionDelete(input: $input) {
      errors {
        message
      }
    }
  }
`

export function doUnsubscribeFromEmailList(integrationId, contactId, listId) {
  return doAppGraphqlRequest(
    EMAIL_MARKETING_UNSUBSCRIBE,
    unsubscribeToEmailListMutation,
    { input: { contactId, integrationId, listId } }
  )
}
